import styled from 'foundations-theming/utils';
import { getOverlayTransition } from '../Modal/ModalTransition';
import { PlainWrapper, TwoWayTransition } from '../TwoWayTransition/TwoWayTransition';
import { StyledDialog } from '../Dialog/Dialog';
import { ModalTransitionContextProvider } from '../Modal/ModalTransitionContext';
import { MODAL_BACKGROUND_TRANSITION_TIMING, SLIDEIN_MODAL_TRANSITION_TIMING } from '../../../constants/times';
import { jsx as _jsx } from "react/jsx-runtime";
const totalTransitionTime = parseInt(SLIDEIN_MODAL_TRANSITION_TIMING, 10);
const overlayTransitionTime = parseInt(MODAL_BACKGROUND_TRANSITION_TIMING, 10);
const dialogTransitionTime = totalTransitionTime - overlayTransitionTime;
const overlayTransition = getOverlayTransition(dialogTransitionTime);
const ModalPanelTransitionWrapper = styled(PlainWrapper).withConfig({
  displayName: "ModalPanelTransition__ModalPanelTransitionWrapper"
})([".hs-private.hs-private.hs-private &{", ";}.hs-private.hs-private.hs-private & ", "{transition-property:", ";transition-delay:", "ms;transition-duration:", "ms;transform:", ";opacity:", ";}"], overlayTransition, StyledDialog, ({
  transitionActive
}) => transitionActive ? 'transform' : 'none', overlayTransitionTime, dialogTransitionTime, ({
  open,
  transitioning
}) => transitioning && `translateX(${open ? '0' : '100'}%)`, ({
  transitioning,
  open
}) => !transitioning && !open ? '0' : '1');
export const ModalPanelTransition = props => /*#__PURE__*/_jsx(TwoWayTransition, Object.assign({}, props, {
  ContextProvider: ModalTransitionContextProvider,
  duration: totalTransitionTime,
  transitionOnMount: true,
  Wrapper: ModalPanelTransitionWrapper
}));